import StandardGateway from '@ad-scripts/adapters/gateways/lib/standard_gateway';
import generateId from 'src/lib/generateId';

const HEADER_CORRELATION_ID = 'Gladly-Correlation-Id';
const V3 = 'v3';

export default class AuthenticationGateway extends StandardGateway {
  constructor(backend) {
    super(backend, V3);
  }

  tokenRefresh() {
    const correlationId = generateId();
    const url = this.endpoint.addUrl;
    const params = { requestName: 'requestTokenRefresh', correlationId };
    return this.http
      .post(`${url}/refresh_tokens`, {}, { headers: { [HEADER_CORRELATION_ID]: correlationId } })
      .then(dto => this.observer.onUpdateSuccess(dto, params))
      .catch(error => this.observer.onUpdateError(error, params));
  }
}
